<template>
  <div>
    <insert-activity-domestic
      v-if="canUpdate"
      :bu-id="buId"
      :guest-period-data-set-id="guestPeriodDataSetId"
      :flux-activity-id="fluxActivityId"
      :date-start-period="dateStartPeriod"
      :date-end-period="dateEndPeriod"
      :time-start-period="timeStartPeriod"
      :time-end-period="timeEndPeriod"
      @update="onChildUpdate"
    />
    <generic-table
      ref="genericTable"
      :headerLabels="headerLabels"
      :elements="getTableElements"
      :options="options"
      :lengthPage="lengthPage"
      @removeElementEvent="removeItem"
    />
  </div>
</template>

<script>
import insertActivityDomestic from './insertActivityDomestic';
import apiConnector from '@/epersonam/apiConnector';
import { Route } from '../../route';
import genericTable from '../genericTable/genericTable';

export default {
  name: 'tableActivityDomestic',

  components: {
    insertActivityDomestic,
    genericTable,
  },

  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    getTableElements() {
      return this.tableElements.map(
        // [{name, qta, umd, ....}] -> [{name, qta, umd}]
        ({ start_date, start_time, duration, full_name, description, percorso }) => ({
          start_date,
          start_time,
          duration,
          full_name,
          description,
          percorso,
        }),
      );
    },
  },

  props: [
    'guestPeriodDataSetId',
    'fluxActivityId',
    'canUpdate',
    'canDelete',
    'dateStartPeriod',
    'dateEndPeriod',
    'timeStartPeriod',
    'timeEndPeriod',
    'siad1Id',
  ],

  data() {
    return {
      activityConfigId: null,
      headerLabels: [
        i18nJS.domestic.date,
        i18nJS.domestic.time,
        i18nJS.domestic.duration,
        i18nJS.user_label,
        i18nJS.domestic.activity,
        'Percorso',
      ],
      tableElements: [],
      buId: window.config.business_unit.id,
      page: 0,
      lengthPage: 20,
      options: {
        actionColumnEnabled: this.canDelete,
        canDeleteRow: this.canDelete,
        infiniteScrollEnable: true,
        handleUpdate: this.handleUpdate,
      },
    };
  },

  methods: {
    handleUpdate(callback) {
      return this.getActivityDomesticUsers();
    },
    addRedRow() {
      let lastSiad4Id = null;
      this.tableElements.forEach((el, i) => {
        const tr = document.querySelector(`#vue-generic-table tbody tr:nth-of-type(${i + 1})`);
        if (el.siad4_id !== lastSiad4Id && tr) tr.classList.add('border-top-red');
        lastSiad4Id = el.siad4_id;
      });
    },
    getActivityDomesticUsers() {
      this.page += 1;
      return apiConnector()
        .get(`${Route.DOMESTIC}/index_flux_domestics_activity.json?siad1_id=${this.siad1Id}`, {
          params: {
            gpds_id: this.guestPeriodDataSetId,
            business_unit_id: this.buId,
            activity_id: this.fluxActivityId,
            start_period: this.dateStartPeriod + ' ' + this.timeStartPeriod,
            end_period: this.dateEndPeriod + ' ' + this.timeEndPeriod,
            per_page: this.lengthPage,
            page: this.page,
          },
        })
        .then(({ data }) => {
          try {
            this.tableElements = this.tableElements.concat(data);
            return data.length;
          } catch (err) {
            return 0;
          }
        })
        .catch((err) => {
          return 0;
        });
    },
    removeItem(item, index) {
      var tableElements = this.tableElements;
      Loader.show();
      if (confirm('Vuoi veramente cancellare questo accesso?')) {
        apiConnector()
          .delete(`${Route.DOMESTIC}/delete_flux_activity.json`, {
            params: { activity_id: tableElements[index].id },
          })
          .then((result) => {
            if (result.data.success != false) {
              tableElements.splice(index, 1);
            } else {
              Utils.appendToFlash('error', 'Azione non riuscita');
            }
          })
          .catch((err) => Utils.appendToFlash('error', 'Azione non riuscita'))
          .finally(() => Loader.hide());
      } else {
        Loader.hide();
      }
    },
    onChildUpdate() {
      this.tableElements = [];
      this.page = 0;
      this.$refs.genericTable.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
    },
  },
  mounted() {
    eventBus.$on('genericTableUpdated', this.addRedRow);
    this.getActivityDomesticUsers();
  },
  destroyed() {
    eventBus.$off('genericTableUpdated', this.addRedRow);
  },
};
</script>

<style lang="scss" scoped></style>
